module.exports = __webpack_public_path__ + "static/media/radioactive-materials-test-manage.2fd1d84f.svg";